export type TPlatform = 'ios' | 'android' | 'other';

export enum EMobileDeviceType {
  iOS = 'ios',
  Android = 'android',
  Unknown = 'unknown',
}
